import { getGuvenilirQRBankList } from "@actions/deposit.js";
import FormItem from "@components/formItem";
import { formatMoney } from "@pages/profile-v2/utils/index.js";
import React from "react";
import { Translate } from "react-localize-redux";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, Stake } from "../baseItems";
import Base from "./base";

export default class GuvenilirQR extends Base {
	constructor(props) {
		super(props);
		getGuvenilirQRBankList().then((res) => {
			this.setState({
				bankList: Object.keys(res.data.message.banks).reduce((prev, c) => {
					prev.push(res.data.message.banks[c]);
					return prev;
				}, []),
			});
		});
		this.state["selectedCurrency"] = "TRY";
	}

	onSelectBankCode(e) {
		this.setState(
			{
				bank_code: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { selectedDeposit } = this.props;
		const { selectedCurrency, bankList, bank_code } = this.state;
		let bankOptions = [{ value: 0, label: translate("PLEASE_SELECT") }];
		bankList &&
			bankList.map((item, index) => {
				let newOpt = { value: item.code, label: item.name };
				bankOptions.push(newOpt);
			});
		let selectedBank = bank_code ? bankOptions.find((o) => o.value === bank_code).value : 0;
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("Payment_Stake")}</ContentTitle>
				<FormItem onRegister={() => this.registerField({ name: "bank_code" })}>
					<Box>
						<BoxTitle>{translate("BANK_NAME")}</BoxTitle>
						<PaymentSelect
							data-testid="step-deposit-amount-bank-picker"
							options={bankOptions}
							value={selectedBank}
							handleSelect={this.onSelectBankCode.bind(this)}
						/>
					</Box>
				</FormItem>
				{this.getCurrencyField(translate)}
				{bank_code &&
					selectedCurrency &&
					selectedCurrency != translate("PLEASE_SELECT") &&
					this.getStakeField()}
				{this.renderMinMax()}
			</Content>
		);
	}

	renderMinMax() {
		const { bank_code, bankList, selectedCurrency } = this.state;
		const { selectedDeposit } = this.props;

		const currencyToUse = selectedCurrency || selectedDeposit?.currencies?.[0]?.currency;
		const currency = selectedDeposit.currencies.filter(
			(item) => item.currency == currencyToUse
		);
		const bank = bankList && bank_code ? bankList.find((i) => i.code === bank_code) : null;
		const min =
			bank && currency && currency[0] && currency[0].deposit
				? bank.limit.min > currency[0].deposit.min
					? bank.limit.min
					: currency[0].deposit.min
				: null;
		const max =
			bank && currency && currency[0] && currency[0].deposit
				? bank.limit.max < currency[0].deposit.max
					? bank.limit.max
					: currency[0].deposit.max
				: null;
		return (
			<Translate>
				{({ translate }) => (
					<div>
						{min && max && (
							<Box>
								<BoxTitle>
									{translate("MIN")} - {translate("MAX")}
								</BoxTitle>
								<Stake>
									{`${formatMoney(min, currencyToUse)} - ${formatMoney(
										max,
										currencyToUse
									)}`}
								</Stake>
							</Box>
						)}
					</div>
				)}
			</Translate>
		);
	}

	goForward(step) {
		const newStep = step + 1,
			{ bank_code, bankList, stake, selectedCurrency, claimsBonus, selectedBonus } =
				this.state,
			{ selectedDeposit } = this.props;
		const bank = bankList && bank_code ? bankList.find((i) => i.code === bank_code) : null;
		const currency = selectedDeposit.currencies.find(
			(item) => item.currency == selectedCurrency
		);
		const min =
			bank && currency && currency.deposit
				? bank.limit.min > currency.deposit.min
					? bank.limit.min
					: currency.deposit.min
				: null;
		const max =
			bank && currency && currency.deposit
				? bank.limit.max < currency.deposit.max
					? bank.limit.max
					: currency.deposit.max
				: null;
		switch (newStep) {
			case 2: {
				if (!this.checkRequiredFields()) {
					return;
				}
				if (stake < min) {
					this.props.showAlert({
						type: "error",
						msg: "STAKE_RANGE_WARNING_MIN",
						title: "ERROR",
					});
					return;
				}
				if (stake > max) {
					this.props.showAlert({
						type: "error",
						msg: "STAKE_RANGE_WARNING_MAX",
						title: "ERROR",
					});
					return;
				}
				if (stake % 10 !== 0) {
					this.props.showAlert({
						type: "error",
						msg: "STAKE_10_MULTIPLES",
						title: "ERROR",
					});
					return;
				}
				this.getAvailableBonuses(newStep);
				break;
			}
			case 3: {
				if (claimsBonus) {
					this.makeExternalPaymentWithBonus(newStep, selectedBonus.id);
				} else {
					this.makeExternalPayment(newStep);
				}
				break;
			}
			default:
				this.setState({
					currentStep: newStep,
				});
		}
	}

	makeExternalPayment(newStep) {
		const { stake, bank_code } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				url_redirect: location.href,
				amount: stake,
				bank_code,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { iban, stake, bank_code } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				url_redirect: location.href,
				amount: stake,
				bank_code,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}
}
